import React from "react";
import NotSubscribedMessageComponent from "./UI/NotSubscribedMessageComponent";

const UKCommunicationRecordClientOrderComponent = () => {
  return (
    <>
      <main className="middle_section dashboard_middle">
        <div className="container">
          <NotSubscribedMessageComponent />
        </div>
      </main>
    </>
  );
};

export default UKCommunicationRecordClientOrderComponent;
